import { PreparationBreadcrumb } from '@modules/OrderPreparation/shared';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface BreadcrumbProps {
    preparationCode: string;
    preparationStatus: number;
}

export const Breadcrumb: React.FC<BreadcrumbProps> = ({
    preparationCode,
    preparationStatus
}) => {
    const { t } = useTranslation('packingModule');

    return (
        <PreparationBreadcrumb
            preparationCode={preparationCode}
            preparationStatus={preparationStatus}
            breadcrumbLabel={t('breadcrumb.packing')}
        />
    );
}; 